import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import {Task} from "../features/tasks/types";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function encodeURIComponent(number: number | string): string {
  const text = number.toString();
  return btoa(text);
}

export function decodeURIComponent(encodedString: string): string {
  const decoded = atob(encodedString);
  return decoded;
}

export function getResourcePath(task: Task): string {
  const resourcePathMap: Record<string, string> = {
    LEAD_TASK: "/dashboard/lead-details",
    APPLICATION_TASK: "/dashboard/application/details",
  };
  return resourcePathMap[task.resourceType];
};

export function isFieldAsCity (value : string) : boolean {
    return value === 'city' ? true : false; 
}; 
 